export default __webpack_public_path__ + "static/media/door.14c4f9dd.svg";